import DicomForm from '@oncolens/oncolens-ui/lib/components/Common/Dicom/DicomForm';
import React from 'react';

interface DicomSectionProps {
	readonly?: boolean;
	patientId: string;
	refetchIntervalMs?: boolean | number;
	emptyText?: string;
}

function DicomSection({
  readonly = false,
  patientId,
  refetchIntervalMs,
  emptyText = ''
}: DicomSectionProps) {
  return (
    <DicomForm
      readonly={readonly}
      patientId={patientId}
      refetchIntervalMs={refetchIntervalMs}
      emptyText={emptyText}
    />
  );
}

export { DicomSection };
